/**
 * Subscription Reducer
 * 
 * Manages state for the new subscription flow supporting
 * both Stripe and Paystack payment providers.
 */

import {
  SET_SUBSCRIPTION_LOADING,
  SET_CURRENT_SUBSCRIPTION,
  SET_AVAILABLE_PLANS,
  SET_SUBSCRIPTION_ERROR,
  CLEAR_SUBSCRIPTION_ERROR,
  SET_PROMO_CODE_STATUS,
  SET_CHECKOUT_SESSION,
  SET_PAYMENT_PROVIDER,
  SET_SELECTED_PLAN,
  RESET_SUBSCRIPTION_STATE,
} from "../constants";

const initialState = {
  // Loading state
  loading: false,

  // Current active subscription
  currentSubscription: null,

  // Available plans from API
  availablePlans: {
    standardPlans: [],
    customPlans: [],
    addonPricing: null,
    paidApps: [],
  },

  // Selected plan for checkout
  selectedPlan: null,

  // Payment provider ("stripe" or "paystack")
  paymentProvider: null,

  // Checkout session data
  checkoutSession: null,

  // Promo code status
  promoCodeStatus: null,

  // Error state
  error: null,
};

const subscriptionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SUBSCRIPTION_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case SET_CURRENT_SUBSCRIPTION:
      return {
        ...state,
        currentSubscription: payload,
        error: null,
      };

    case SET_AVAILABLE_PLANS:
      return {
        ...state,
        availablePlans: {
          standardPlans: payload.standard_plans || [],
          customPlans: payload.custom_plans || [],
          addonPricing: payload.addon_pricing || null,
          paidApps: payload.paid_apps || [],
        },
        error: null,
      };

    case SET_SELECTED_PLAN:
      return {
        ...state,
        selectedPlan: payload,
      };

    case SET_PAYMENT_PROVIDER:
      return {
        ...state,
        paymentProvider: payload,
      };

    case SET_CHECKOUT_SESSION:
      return {
        ...state,
        checkoutSession: payload,
      };

    case SET_PROMO_CODE_STATUS:
      return {
        ...state,
        promoCodeStatus: payload,
      };

    case SET_SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: payload,
      };

    case CLEAR_SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: null,
      };

    case RESET_SUBSCRIPTION_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default subscriptionReducer;
